import React from 'react';
import './style.css';
import ListExam from './component/listExam';
import _ from 'lodash';
import callApi from '../../services/callApi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class ResuiltExam extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            questions: this.props.questions,
            exam: this.props.exam,
            spend_time: this.props.spend_time,
            data: [],
            exam_id:this.props.exam_id
        };
    }

    async componentDidMount(){
        const {exam_id} = this.state;
        const response = await callApi('v1/exam/getRelatedArticles/'+exam_id, 'get');

        if(response.code != 200){
            alert('Không tìm thấy bài tập tự luyện');
            return null;
            window.location.reload();
        }
        this.setState({data:response.dataFetch});

    }

    componentWillReceiveProps(nextProps){
        this.setState({
            questions : (this.props.questions != nextProps.questions) ? nextProps.questions : this.props.questions,
            exam : (this.props.exam != nextProps.exam) ? nextProps.exam : this.props.exam,
            spend_time : (this.props.spend_time != nextProps.spend_time) ? nextProps.spend_time : this.props.spend_time,
        })
    }

    render(){
        const {questions,exam,spend_time, data} = this.state;
        let total_true = 0;
        questions.map(item => {
            if(item.type == 0){
                if(item.content.answered == item.content.correct_option){
                    total_true ++;
                }
            } else if(item.type == 1){
                if(item.content.answered == item.content.sub_question[0].correct_option){
                    total_true ++;
                }
            }
        });
        
        return(
            <div className="container" id="page-result-exam-summary">
                <div className="left fl">
                    <div className="banner">
                        <h3 className="title white">{exam.title}</h3><br/>
                        <div className="content white">
                            <div className="circle">
                                <p>Bài làm đúng</p>
                                <span className="boldText" style={{fontSize:"36px"}}>{total_true + '/' + questions.length}</span>
                            </div>
                            <div className="circle">
                                <p>Thời gian</p>
                                <span className="boldText" style={{fontSize:"36px"}}>{spend_time}</span>
                            </div>
                        </div>
                        <div className="footer">
                            <a className="bntSend" style={{ background: "#fff", color: "#262626" }} onClick={this.props.onChangePageViewAnswer}>Xem đáp án <span style={{fontSize: "20px",lineHeight:"15px",marginLeft:"10px"}}>&rsaquo;</span></a>
                        </div>
                    </div>
                    <ListExam lengthData={data.length} data={data}/>
                </div>
                <div className="right fl">
                </div>
                <div className="clear"></div>
            </div>
        )
    }
}
  export default ResuiltExam;
